export const HOMEPAGE_ROUTE = '/'
export const SSO_VIEWER = '/viewer'
export const SSO_ACCOUNT = '/account'
export const SSO_TENANCY = '/tenancy'
export const SSO_USER_PROFILE = '/user-profile'
export const SSO_EDIT_PROFILE = '/edit-profile'
export const SSO_ACTIVE_ACCOUNT = '/activate-account'
export const SSO_CALLBACK = '/auth/callback'



export const ERROR_404_ROUTE = '/error/404';
export const ERROR_500_ROUTE = '/error/500';
